{
  "MACROS": {
    "HEADER": "Macros",
    "DESCRIPTION": "Makro ir saglabātu darbību kopa, kas palīdz klientu apkalpošanas aģentiem viegli veikt uzdevumus. Aģenti var definēt darbību kopu, piemēram, sarunas marķēšanu ar etiķeti, sarunas transkripta nosūtīšanu uz e-pastu, pielāgota atribūta atjaunināšanu utt., un viņi var veikt šīs darbības ar vienu klikšķi.",
    "LEARN_MORE": "Uzzināt vairāk par makro",
    "COUNT": "{n} macro | {n} macros",
    "HEADER_BTN_TXT": "Pievienot jaunu makro",
    "HEADER_BTN_TXT_SAVE": "Saglabāt makro",
    "LOADING": "Notiek makro iegūšana",
    "SEARCH_PLACEHOLDER": "Search macros...",
    "NO_RESULTS": "No macros found matching your search",
    "ERROR": "Radās kļūda. Lūdzu, mēģiniet vēlreiz",
    "ORDER_INFO": "Makro darbosies tādā secībā, kādā Jūs pievienosit savas darbības. Jūs varat tos pārkārtot, velkot tos aiz roktura kas atrodas blakus katram mezglam.",
    "ADD": {
      "FORM": {
        "NAME": {
          "LABEL": "Makro nosaukums",
          "PLACEHOLDER": "Ievadiet sava makro nosaukumu",
          "ERROR": "Lai izveidotu makro, ir nepieciešams nosaukums"
        },
        "ACTIONS": {
          "LABEL": "Darbības"
        }
      },
      "API": {
        "SUCCESS_MESSAGE": "Makro ir veiksmīgi pievienots",
        "ERROR_MESSAGE": "Nevar izveidot makro. Lūdzu, vēlāk mēģiniet vēlreiz"
      }
    },
    "LIST": {
      "TABLE_HEADER": {
        "NAME": "Nosaukums",
        "CREATED BY": "Izveidoja",
        "LAST_UPDATED_BY": "Pēdējo reizi atjaunināja",
        "VISIBILITY": "Redzamība",
        "ACTIONS": "Darbības"
      },
      "404": "Nav atrasts neviens makro"
    },
    "DELETE": {
      "TOOLTIP": "Dzēst makro",
      "CONFIRM": {
        "MESSAGE": "Vai vēlaties izdzēst ",
        "YES": "Jā, Dzēst",
        "NO": "Nē"
      },
      "API": {
        "SUCCESS_MESSAGE": "Makro ir veiksmīgi izdzēsts",
        "ERROR_MESSAGE": "Dzēšot makro radās kļūda. Lūdzu, vēlāk mēģiniet vēlreiz"
      }
    },
    "VIEW": {
      "TOOLTIP": "View macro"
    },
    "EDIT": {
      "TOOLTIP": "Rediģēt makro",
      "API": {
        "SUCCESS_MESSAGE": "Makro ir veiksmīgi atjaunināts",
        "ERROR_MESSAGE": "Nevarēja atjaunināt makro. Lūdzu, vēlāk mēģiniet vēlreiz"
      }
    },
    "EDITOR": {
      "START_FLOW": "Sākt Plūsmu",
      "END_FLOW": "Beigt Plūsmu",
      "LOADING": "Notiek makro iegūšana",
      "ADD_BTN_TOOLTIP": "Pievienot jaunu darbību",
      "DELETE_BTN_TOOLTIP": "Dzēst Darbību",
      "VISIBILITY": {
        "LABEL": "Makro Redzamība",
        "GLOBAL": {
          "LABEL": "Publisks",
          "DESCRIPTION": "Šis makro ir publiski pieejams visiem šī konta aģentiem.",
          "CREATE_DISABLED_DESCRIPTION": "Only administrators can create public macros.",
          "EDIT_DISABLED_DESCRIPTION": "Only administrators can edit public macros."
        },
        "PERSONAL": {
          "LABEL": "Privāts",
          "DESCRIPTION": "Šis makro būs privāts Jums un nebūs pieejams citiem."
        }
      }
    },
    "EXECUTE": {
      "BUTTON_TOOLTIP": "Izpildīt",
      "PREVIEW": "Priekšskatīt Makro",
      "EXECUTED_SUCCESSFULLY": "Makro ir veiksmīgi izpildīts"
    },
    "ERRORS": {
      "ATTRIBUTE_KEY_REQUIRED": "Nepieciešama atribūta atslēga",
      "FILTER_OPERATOR_REQUIRED": "Nepieciešams filtra operators",
      "VALUE_REQUIRED": "Nepieciešama vērtība",
      "VALUE_MUST_BE_BETWEEN_1_AND_998": "Vērtībai ir jābūt no 1 līdz 998",
      "ACTION_PARAMETERS_REQUIRED": "Nepieciešami darbības parametri",
      "ATLEAST_ONE_CONDITION_REQUIRED": "Ir nepieciešams vismaz viens nosacījums",
      "ATLEAST_ONE_ACTION_REQUIRED": "Ir nepieciešama vismaz viena darbība"
    },
    "ACTIONS": {
      "ASSIGN_TEAM": "Piešķirt Komandai",
      "ASSIGN_AGENT": "Piešķirt Aģentu",
      "ADD_LABEL": "Pievienot Etiķeti",
      "REMOVE_LABEL": "Noņemt Etiķeti",
      "REMOVE_ASSIGNED_AGENT": "Remove Assigned Agent",
      "REMOVE_ASSIGNED_TEAM": "Noņemt Piešķirto Komandu",
      "SEND_EMAIL_TRANSCRIPT": "Nosūtīt uz E-pastu Transkriptu",
      "MUTE_CONVERSATION": "Izslēgt Sarunu",
      "SNOOZE_CONVERSATION": "Atlikt Sarunu",
      "RESOLVE_CONVERSATION": "Atrisināt Sarunu",
      "SEND_ATTACHMENT": "Sūtīt Pielikumu",
      "SEND_MESSAGE": "Nosūtīt Ziņojumu",
      "CHANGE_PRIORITY": "Mainīt prioritāti",
      "ADD_PRIVATE_NOTE": "Pievienot Privātu Piezīmi",
      "SEND_WEBHOOK_EVENT": "Nosūtīt Webhook Notikumu"
    },
    "PRIORITY_TYPES": {
      "NONE": "Nav",
      "LOW": "Zema",
      "MEDIUM": "Vidēja",
      "HIGH": "Augsta",
      "URGENT": "Steidzama"
    }
  }
}
